import cn from 'classnames';
import { MdOutlineStickyNote2 } from 'react-icons/md';
import { NetworkMetadata } from '@blisspointmedia/bpm-types/dist/LogsTracker';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { LogStatus, LogStatusType } from './logs-tracker-constants';
import {
  formatMissingCompanies,
  getMissingCompanies,
  getProgress,
  hasNotes,
  isAllDidNotRun
} from './logs-tracker-utils';

interface NetworkCardProps {
  network: NetworkMetadata;
  status: LogStatusType;
  isEdited: boolean;
  isSelected: boolean;
  onClick: () => void;
}

export const NetworkCard = ({
  network,
  status,
  isEdited,
  isSelected,
  onClick
}: NetworkCardProps) => {
  const { done, total } = getProgress(network);
  const missing = getMissingCompanies(network);

  return (
    <InteractiveDiv
      className={cn('network-card', {
        selected: isSelected,
        'all-dnr': isAllDidNotRun(network)
      })}
      onClick={onClick}
    >
      <div className='network-card-header'>
        <span className='network-name'>{network.network}</span>
        {hasNotes(network) && <MdOutlineStickyNote2 className='notes-icon' title='Has notes' />}
        {isEdited && <span className='unsaved-dot' title='Unsaved changes' />}
        <span className='network-count'>
          {done}/{total}
        </span>
      </div>
      <div className='progress-track'>
        <div
          className='progress-fill'
          style={{ width: `${total ? (done / total) * 100 : 100}%` }}
        />
      </div>
      {status === LogStatus.IN_PROGRESS && (
        <div className='network-missing' title={missing.join(', ')}>
          <span className='network-missing-label'>Missing:</span> {formatMissingCompanies(missing)}
        </div>
      )}
    </InteractiveDiv>
  );
};
